// Main authentication hook
import { useContext } from "react";
import { AuthContext } from "../components/AuthProvider";
/**
 * Hook to access authentication context
 * Must be used within AuthProvider
 */
export function useAuth() {
    const context = useContext(AuthContext);
    if (!context) {
        throw new Error("useAuth must be used within an AuthProvider");
    }
    return context;
}
